var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgChain = function SvgChain(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.3281 16.334H18.6615C17.3728 16.334 16.3281 17.3787 16.3281 18.6673V23.334C16.3281 24.6226 17.3728 25.6673 18.6615 25.6673H23.3281C24.6168 25.6673 25.6615 24.6226 25.6615 23.334V18.6673C25.6615 17.3787 24.6168 16.334 23.3281 16.334Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.32812 2.33398H4.66146C3.37279 2.33398 2.32812 3.37865 2.32812 4.66732V9.33398C2.32812 10.6226 3.37279 11.6673 4.66146 11.6673H9.32812C10.6168 11.6673 11.6615 10.6226 11.6615 9.33398V4.66732C11.6615 3.37865 10.6168 2.33398 9.32812 2.33398Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.17188 16.334V17.5007C8.17188 18.1195 8.41771 18.713 8.85529 19.1506C9.29288 19.5882 9.88637 19.834 10.5052 19.834H11.6719",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.3281 8.16602H17.4948C18.1136 8.16602 18.7071 8.41185 19.1447 8.84943C19.5823 9.28702 19.8281 9.88051 19.8281 10.4993V11.666",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgChain;